<div class="p-d-flex p-jc-center p-ai-center" style="height: 100vh">
  <div class="card_width" style="width: 420px;">
    <p-card header="TEST ONLY — 2FA Approval">
      <p style="font-size: 13px; color: #888;">
        This page stands in for the mobile app's approve/deny prompt until that flow is built.
        It is not part of the real login experience.
      </p>

      <div class="p-field">
        <label>Request ID</label>
        <input type="text" pInputText class="form-control" [(ngModel)]="pendingId"
          placeholder="Paste the pending request ID" (blur)="checkStatus()" />
      </div>

      <div *ngIf="error" style="color: red; margin: 10px 0;">{{error}}</div>

      <div *ngIf="status" style="margin: 10px 0;">
        Status: <b>{{status}}</b>
      </div>

      <div class="p-d-flex p-jc-center" style="gap: 10px; margin-top: 15px;" *ngIf="!resolved">
        <button pButton type="button" label="Approve" class="p-button-success" (click)="decide(true)" [disabled]="isLoading"></button>
        <button pButton type="button" label="Deny" class="p-button-danger" (click)="decide(false)" [disabled]="isLoading"></button>
      </div>

      <div *ngIf="resolved && status === 'APPROVED'" style="text-align: center; color: green; margin-top: 10px;">
        Approved — the login page should complete automatically.
      </div>
      <div *ngIf="resolved && status === 'DENIED'" style="text-align: center; color: red; margin-top: 10px;">
        Denied.
      </div>
    </p-card>
  </div>
</div>
